export enum KnmPmFormFieldsNamesTemplatesEnum {
  MANUAL_ADDRESS = 'manualAddress',
  REGION = 'region',
  KNO_ORGANIZATION = 'knoOrganizationPm',
  SUPERVISION_TYPE = 'supervisionTypePm',
  PM_TYPE = 'pmType',
  START_DATE = 'startDate',
  STOP_DATE = 'stopDate',
  PM_FULLNAME = 'fullName',
  PM_POSITION_SIGNER = 'positionSigner',
  ORGANIZATION_FOR_SELECT = 'organizationsForSelect',
  PM_FORM = 'pmForm',
  LOCATION = 'location',
  OFFICIAL_FULL_NAME = 'officialFullName',
  PM_SIGNER_POSITION = 'pmSignerPosition',

  DOC_TARGET = 'docTarget',
  DOC_TARGET_ITEM = 'docTarget[i]',
  DOC_TARGET_ITEM_DOC_TARGET_TYPE = 'docTarget[i].docTargetType',
  DOC_TARGET_ITEM_ERVK_CONTROL_KIND_DOC_TARGET = 'docTarget[i].ervkControlKindDocTarget',

  EXTENSION_ATTACHMENT = 'periodExtension.attachment',
  EXTENSION_NUMBER = 'periodExtension.decisionNumber',
  EXTENSION_DATE = 'periodExtension.decisionDateTime',
  EXTENSION_AMOUNT = 'periodExtension.amountDays',

  SUSPENSION_ATTACHMENT = 'suspensionEvents[i].attachments',
  SUSPENSION_EVENT = 'suspensionEvents[i].event',
  SUSPENSION_NUMBER = 'suspensionEvents[i].decisionNumber',
  SUSPENSION_DATE = 'suspensionEvents[i].decisionDateTime',
  SUSPENSION_START_DATE = 'suspensionEvents[i].startDate',
  SUSPENSION_STOP_DATE = 'suspensionEvents[i].stopDate',

  NOTE_WARNING = 'noteWarning',
  CONTENT_WARNING = 'contentWarning',
  OBJECTION_WARNING = 'objectionWarning',
  EXAMPLE_WARNING = 'exampleWarning',
  IS_PRESENT_IN_IT_REGISTRY = 'isPresentInItRegistry',
  IS_SONKO_REGISTRY = 'isSonko',
  IS_MSP_REGISTRY = 'mspCode',
  IS_NKO_REGISTRY = 'isNko',
  EVENTS = 'eventsPm',
  REASONS = 'reasonsPm',
  REASON = 'reasonsPm[i]',
  REASON_TYPE = 'reasonsPm[i].type',
  REASON_LINK_VALIDATION = 'reasonsPm[i].linkValidation',
  REASON_LINK = 'reasonsPm[i].links',
  REASON_TEXT = 'reasonsPm[i].text',
  REASON_DATE = 'reasonsPm[i].date',
  IS_UNABLE_TO_REFUSE = 'isUnableToRefuse',
  REASON_DATE_REQUIREMENT = 'reasonsPm[i].dateRequirement',
  REASON_RISK_INDICATORS_VALUE = 'reasonsPm[i].riskIndicators',
  REASON_RISK_INDICATOR_VALUE = 'reasonsPm[i].riskIndicators[i]',
  REASON_RISK_INDICATOR = 'reasonsPm[i].riskIndicators[i].riskIndicator',
  REASON_RISK_INDICATOR_AUTO = 'reasonsPm[i].riskIndicators[i].indicatorRiskAuto',
  REASON_RISK_INDICATOR_FILE = 'reasonsPm[i].riskIndicators[i].indicatorRiskAttachment',
  REASON_ASSIGNMENT_NUMBER = 'reasonsPm[i].assignmentNumber',
  REASON_ASSIGNMENT_DATE = 'reasonsPm[i].assignmentDate',
  REASON_ASSIGNMENT_FULLNAME = 'reasonsPm[i].fullName',
  REASON_REQUIREMENT_DETAILS = 'reasonsPm[i].requirementDetails',
  REASON_LAST_CONDUCTED_KNM_DATE = 'reasonsPm[i].lastConductedKnmDate',
  REASON_PROGRAM_NUMBER = 'reasonsPm[i].programNumber',
  REASON_PROGRAM_ATTACHMENT = 'reasonsPm[i].programAttachment',
  RESCHEDULING_NEW_START_DATE_ID = 'rescheduling[i].newStartDate',
  RESCHEDULING_NEW_END_DATE_ID = 'rescheduling[i].newEndDate',
  RESCHEDULING_NEW_DURATION_DAYS_ID = 'rescheduling[i].newDirectDurationDays',
  RESCHEDULING_NEW_DURATION_HOURS_ID = 'rescheduling[i].newDurationHours',
  ABROGATION_REASON_ID = 'abrogation.reasonId',
  ABROGATION_LINK = 'abrogation.link',
  REASON_PLAN_KNM = 'reasonsPm[i].planKnm',
  REASON_ORDER = 'reasonsPm[i].order',
  EVENT_TYPE = 'eventsPm[i].type',
  EVENT_INTERACTION_CATEGORY = 'eventsPm[i].interactionCategory',
  EVENT_START_DATE = 'eventsPm[i].startDate',
  EVENT_STOP_DATE = 'eventsPm[i].stopDate',
  EVENT_SUBMITTED_DOCUMENTS = 'eventsPm[i].submittedDocuments',
  EVENT_SUBMITTED_DOCUMENTS_TITLE_ID = 'eventsPm[i].submittedDocuments[i].documentTitle',
  EVENT_SUBMITTED_DOCUMENTS_REQUEST_DATETIME_ID = 'eventsPm[i].submittedDocuments[i].requestDateTime',
  EVENT_SUBMITTED_DOCUMENTS_DEADLINE_ID = 'eventsPm[i].submittedDocuments[i].submissionDeadline',
  EVENT_SUBMITTED_DOCUMENTS_SUBMISSION_DATETIME_ID = 'eventsPm[i].submittedDocuments[i].submissionDateTime',
  EVENT_SUBMITTED_DOCUMENTS_FILE_ID = 'eventsPm[i].submittedDocuments[i].files',
  EVENT_UAV_TECHNOLOGIES = 'eventsPm[i].uavTechnologies',
  EVENT_UAV_TECHNOLOGIES_TYPE = 'eventsPm[i].uavTechnologies[i].type',
  EVENT_UAV_TECHNOLOGIES_NAME = 'eventsPm[i].uavTechnologies[i].name',
  INN = 'inn',
  OGRN = 'ogrn',
  ORGANIZATION_NAME = 'organizationName',
  OKVEDS = 'okveds',
  OKVED = 'okveds[i]',
  OKVED_OKVED = 'okveds[i].okved',
  SNILS = 'snils',
  DOCUMENT = 'document',
  COUNTRY = 'country',
  RAFP_NZA = 'rafpNza',
  KPP = 'kpp',
  OBJECTS = 'objectsPm',
  OBJECT = 'objectsPm[i]',
  OBJECT_OBJECT_NAME = 'objectsPm[i].name',
  OBJECT_ADDRESS = 'objectsPm[i].address',
  OBJECT_OBJECT_TYPE = 'objectsPm[i].objectType',
  OBJECT_OBJECT_KIND = 'objectsPm[i].objectKind',
  OBJECT_OBJECT_SUB_KIND = 'objectsPm[i].objectSubKind',
  OBJECT_RISK_CATEGORY = 'objectsPm[i].riskCategory',
  OBJECT_REGION = 'objectsPm[i].region',
  OBJECT_MANUAL_ADDRESS = 'objectsPm[i].manualAddress',
  INSPECTORS = 'inspectorsErknm',
  INSPECTOR = 'inspectorsErknm[i]',
  INSPECTOR_FULL_NAME = 'inspectorsErknm[i].fullName',
  INSPECTOR_POSITION = 'inspectorsErknm[i].position',
  EXPERTS = 'experts',
  EXPERT = 'experts[i]',
  EXPERT_TITLE = 'experts[i].title',
  EXPERT_TYPE = 'experts[i].type',
  COLLABORATING_ORGANIZATIONS = 'collaboratingOrganizationsErknm',
  COLLABORATING_ORGANIZATIONS_ITEM = 'collaboratingOrganizationsErknm[i]',
  COLLABORATING_ORGANIZATIONS_ITEM_ORGANIZATION = 'collaboratingOrganizationsErknm[i].organization',
  COLLABORATING_ORGANIZATIONS_ITEM_TITLE = 'collaboratingOrganizationsErknm[i].title',
  IS_HAS_NOTIFICATION = 'isHasNotification',
  IS_REJECT_SUBJECT = 'isRejectSubject',
  RESULT_OF_INSPECTION = 'resultOfInspection',
  REQUIREMENTS_NPA = 'requirementsNpa',
  REQUIREMENTS_NPA_I = 'requirementsNpa[i]',
  REQUIREMENTS_NPA_ITEM = 'requirementsNpa[i].npa',
  REQUIREMENTS_NPA_MANDATORY = 'requirementsNpa[i].mandatory',
  REQUIREMENTS_NPA_MANDATORY_ITEM = 'requirementsNpa[i].mandatory[i].id',
  APPROVE_DOC_ITEM = 'approveDocs[i].approveDoc',
  IS_ORGANIZATION_NEW = 'isOrganizationNew',
  SUBJECT_TYPE_PM = 'subjectTypePm',
  SUBJECT_ADDRESS = 'locationAddress',
  SUBJECT_MANUAL_ADDRESS = 'locationmanualAddress',
  NOTIFICATION_DATE = 'subjectNotifications[i].date',
  NOTIFICATION_TYPE = 'subjectNotifications[i].type',
  NOTIFICATION_COMMENT = 'subjectNotifications[i].comment',
  REJECT_DATE = 'pmReject[i].date',
  REJECT_CANCELED_REASON = 'pmReject[i].canceledReason',
  PM_RESULT_DECISIONS = 'pmResultDecisions',
  PM_RESULT_DECISION = 'pmResultDecisions[i]',
  PM_RESULT_DECISION_DECISION_NUMBER = 'pmResultDecisions[i].number',
  PM_RESULT_DECISION_DECISION_DATE = 'pmResultDecisions[i].date',
  PM_RESULT_DECISION_FILE = 'pmResultDecisions[i].attachment',
  PM_RESULT_DECISION_KIND_DECISION = 'pmResultDecisions[i].kindDecision',
  PM_RESULT_DECISION_DEADLINE = 'pmResultDecisions[i].deadline',
  PM_RESULT_DECISION_INFORMATION = 'pmResultDecisions[i].information',
  PM_RESULT_DECISION_SIGNER_FULL_NAME = 'pmResultDecisions[i].signerFullName',
  PM_RESULT_DECISION_SIGNER_POSITION = 'pmResultDecisions[i].signerPosition',
  PM_RESULT_DECISION_FOUNDER_SUBJECT_TYPE_PM = 'pmResultDecisions[i].founder.subjectTypePm',
  PM_RESULT_DECISION_FOUNDER_INN = 'pmResultDecisions[i].founder.inn',
  PM_RESULT_DECISION_FOUNDER_OGRN = 'pmResultDecisions[i].founder.ogrn',
  PM_RESULT_DECISION_FOUNDER_ORGANIZATION_NAME = 'pmResultDecisions[i].founder.organizationName',
  PM_RESULT_DECISION_FOUNDER_OKVEDS = 'pmResultDecisions[i].founder.okveds',
  PM_RESULT_DECISION_FOUNDER_OKVED = 'pmResultDecisions[i].founder.okveds[i]',
  PM_RESULT_DECISION_FOUNDER_OKVED_OKVED = 'pmResultDecisions[i].founder.okveds[i].okved',
  PM_RESULT_DECISION_FOUNDER_SNILS = 'pmResultDecisions[i].founder.snils',
  PM_RESULT_DECISION_FOUNDER_DOCUMENT = 'pmResultDecisions[i].founder.document',
  PM_RESULT_DECISION_FOUNDER_COUNTRY = 'pmResultDecisions[i].founder.country',
  PM_RESULT_DECISION_FOUNDER_RAFP_NZA = 'pmResultDecisions[i].founder.rafpNza',
  PM_RESULT_DECISION_FOUNDER_KPP = 'pmResultDecisions[i].founder.kpp',

  PM_IS_VIOLATED_REQUIREMENTS_MANDATORY = 'isViolatedMandatoryRequirements',
  PM_VIOLATED_REQUIREMENTS = 'violatedMandatoryRequirements',
  PM_VIOLATED_REQUIREMENTS_MANDATORY = 'violatedMandatoryRequirements[i].violatedMandatory',
  PM_VIOLATED_REQUIREMENTS_MANDATORY_ITEM = 'violatedMandatoryRequirements[i].violatedMandatory[i].mandatory',
  PM_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_CATEGORY = 'violatedMandatoryRequirements[i].violatedMandatory[i].category',
  PM_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_VIOLATIONS = 'violatedMandatoryRequirements[i].violatedMandatory[i].violations',
  PM_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_VIOLATION_TITLE = 'violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].title',
  PM_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_VIOLATION_FIXED_ON_PLACE = 'violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].isFixedOnPlace',
  PM_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_VIOLATION_FIXED = 'violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].isFixed',

  PM_RESULT_DECISION_VIOLATED_MANDATORY = 'pmResultDecisions[i].violatedMandatoryRequirements',
  PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATIONS = 'pmResultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations',
  PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIXED_ON_PLACE = 'pmResultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].isFixedOnPlace',
  PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIXED = 'pmResultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].isFixed',
  PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_PLAN_EXPLANATIONS = 'pmResultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixPlanExplanations',
  PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_PLAN_EXPLANATIONS_REQUIRED = 'pmResultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixPlanExplanationsRequired',
  PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_PLAN_DATES = 'pmResultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixPlanDates',
  PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_PLAN_DATES_REQUIRED = 'pmResultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixPlanDatesRequired',
  PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_PLAN_DATE = 'pmResultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixPlanDates[i].value',
  PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_PLAN_METHODS = 'pmResultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixPlanMethods',
  PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_PLAN_METHODS_REQUIRED = 'pmResultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixPlanMethodsRequired',
  PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_FACT_METHOD = 'pmResultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixFactMethod',
  PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_PLAN_METHOD = 'pmResultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixPlanMethods[i].value',
  PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_PLAN_EXPLANATION = 'pmResultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixPlanExplanations[i].value',
  PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_PLAN_EXPLANATION_REACT_QUILL_EDITOR = 'pmResultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixPlanExplanations[i].valueReactQuillEditor',
  PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION = 'pmResultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixes',
  PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_TYPES = 'pmResultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixes[i].type',
  PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_TYPE = 'pmResultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixes[i].type[i].value',
  PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_TYPE_EXPLANATION = 'pmResultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixes[i].explanationMaterial',
  PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_TYPE_EXPLANATION_REACT_QUILL_EDITOR = 'pmResultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixes[i].explanationMaterialReactQuillEditor',
  PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_METHOD = 'pmResultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixes[i].method',
  PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_FILES = 'pmResultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixes[i].attachments',
  PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_FILES_VIDEO_LINK = 'pmResultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixes[i].attachments[i].link.value',
  PM_RESULT_DECISION_VIOLATED_MANDATORY_VIOLATION_FIX_GRADE = 'pmResultDecisions[i].violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixes[i].grade',
  PM_RESULT_DECISION_ORGANIZATION_FAMILIARIZATION_NOTIFICATIONS_TYPE = 'pmResultDecisions[i].familiarizationNotifications[i].knmNoticeType',
  PM_RESULT_DECISION_ORGANIZATION_FAMILIARIZATION_NOTIFICATIONS_NOTICE_DATE = 'pmResultDecisions[i].familiarizationNotifications[i].noticeDate',
  PM_RESULT_DECISION_ORGANIZATION_FAMILIARIZATION_NOTIFICATIONS_NOTE = 'pmResultDecisions[i].familiarizationNotifications[i].note',

  ACT = 'act',
  ACT_CREATION_ACT_DATE_TIME = 'act.creationActDateTime',
  ACT_HOLDING_DATE_TIME = 'act.holdingDateTime',
  ACT_KNO_INSPECTORS = 'act.knoInspectors',
  ACT_KNO_INSPECTOR = 'act.knoInspectors[i]',
  ACT_KNO_INSPECTOR_KNO_INSPECTOR = 'act.knoInspectors[i].knoInspector',
  ACT_KNO_INSPECTOR_FULL_NAME = 'act.knoInspectors[i].fullName',
  ACT_KNO_INSPECTOR_POSITION = 'act.knoInspectors[i].position',
  ACT_FIO_READER = 'act.fioReader',
  ACT_REFUSER_FIO = 'act.refuserFio',
  ACT_REFUSER_TITLE = 'act.refuserTitle',
  ACT_TITLE_READER = 'act.titleReader',
  ACT_DURATION_DAYS = 'act.durationDays',
  ACT_DURATION_HOURS = 'act.durationHours',
  ACT_ACQUAINTANCE_TYPE = 'act.acquaintanceType',
  ACT_ACQUAINTANCE_LACK_TYPE = 'act.acquaintanceLackType',
  ACT_TYPE_ACT = 'act.typeAct',
  ACT_CANCELED_REASON = 'act.canceledReason',
  ACT_CANCELED_REASON_DESCRIPTION = 'act.canceledReasonDescription',
  ACT_CANCELED_REASON_DESCRIPTION_REACT_QUILL_EDITOR = 'act.canceledReasonDescriptionReactQuillEditor',
  ACT_DOCUMENTS_ATTACHMENTS = 'act.document.attachments',

  ACT_IS_VIOLATED_REQUIREMENTS_MANDATORY = 'act.isViolatedMandatoryRequirements',
  ACT_VIOLATED_REQUIREMENTS = 'act.violatedMandatoryRequirements',
  ACT_VIOLATED_REQUIREMENTS_MANDATORY = 'act.violatedMandatoryRequirements[i].violatedMandatory',
  ACT_VIOLATED_REQUIREMENTS_MANDATORY_ITEM = 'act.violatedMandatoryRequirements[i].violatedMandatory[i].mandatory',
  ACT_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_CATEGORY = 'act.violatedMandatoryRequirements[i].violatedMandatory[i].category',
  ACT_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_VIOLATIONS = 'act.violatedMandatoryRequirements[i].violatedMandatory[i].violations',
  ACT_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_VIOLATION_TITLE = 'act.violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].title',
  ACT_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_VIOLATION_FIXED_ON_PLACE = 'act.violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].isFixedOnPlace',
  ACT_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_VIOLATION_TITLE_REACT_QUILL_EDITOR = 'act.violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].descriptionReactQuillEditor',
  ACT_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_VIOLATION_FIXED = 'act.violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].isFixed',
  ACT_VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION = 'act.violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixes',
  ACT_VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION_FIX_TYPES = 'act.violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixes[i].type',
  ACT_VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION_FIX_TYPE = 'act.violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixes[i].type[i].value',
  ACT_VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION_FIX_METHOD = 'act.violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixes[i].method',
  ACT_VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION_FIX_FILES = 'act.violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixes[i].attachments',
  ACT_VIOLATED_REQUIREMENTS_MANDATORY_ELIMINATION_VIOLATION_FIX_FILES_VIDEO_LINK = 'act.violatedMandatoryRequirements[i].violatedMandatory[i].violations[i].fixes[i].attachments[i].link.value',
  ACT_FAMILIARIZATION_NOTIFICATIONS_TYPE = 'act.familiarizationNotifications[i].knmNoticeType',
  ACT_FAMILIARIZATION_NOTIFICATIONS_NOTICE_DATE = 'act.familiarizationNotifications[i].noticeDate',
  ACT_FAMILIARIZATION_NOTIFICATIONS_NOTE = 'act.familiarizationNotifications[i].note',
  ACT_REMARKS_TEXT = 'act.remarks[i].text',
  ACT_REMARKS_TEXT_REACT_QUILL_EDITOR = 'act.remarks[i].textReactQuillEditor',
  ACT_REMARKS_SIGNER_FULLNAME = 'act.remarks[i].signerFullName',
  ACT_REMARKS_SIGNER_POSITION = 'act.remarks[i].signerPosition',
  ACT_REMARKS_DATE = 'act.remarks[i].date',

  ACT_EVENTS = 'act.events',
  ACT_EVENT = 'act.events[i]',
  ACT_EVENT_INSPECTORS = 'act.events[i].inspectors',
  ACT_EVENT_INSPECTOR_FULL_NAME = 'act.events[i].inspectors[i].fullName',
  ACT_EVENT_START_DATE = 'act.events[i].startDate',
  ACT_EVENT_STOP_DATE = 'act.events[i].stopDate',
  ACT_EVENT_LINK_VKS = 'act.events[i].linkVks',
  ACT_EVENT_LINK_VIDEO = 'act.events[i].linkVideo',
  ACT_EVENT_PROTOCOL_FILE_ATTACHMENTS = 'act.events[i].protocol.file.attachments',
  ACT_EVENT_TYPE = 'act.events[i].type',
  ACT_EVENT_UAV_TECHNOLOGIES = 'act.events[i].uavTechnologies',
  ACT_EVENT_UAV_TECHNOLOGIES_TYPE = 'act.events[i].uavTechnologies[i].type',
  ACT_EVENT_UAV_TECHNOLOGIES_NAME = 'act.events[i].uavTechnologies[i].name',
  ACT_FIO_AND_POSITION_SIGNER = 'act.fioAndPositionSinger',
  ACT_FIO_SIGNER = 'act.fioSigner',
  ACT_TITLE_SIGNER = 'act.titleSigner',
  ACT_NUMBER_ACT = 'act.numberAct',
  ACT_INVOLVED_EXPERTS = 'act.involvedExperts[i].expert',
  ACT_INVOLVED_WITNESSES_VALUE = 'act.involvedWitnesses[i].fullName',

  TAKEN_MEASURES = 'takenMeasures',
  TAKEN_MEASURES_VALUE = 'takenMeasures[i].value',

  VIDEO_CALL_INFO = 'videoCallInfo',
  VIDEO_CALL_INFO_ITEM = 'videoCallInfo[i]',
  VIDEO_CALL_INFO_ITEM_LINK = 'videoCallInfo[i].link',
  VIDEO_CALL_INFO_ITEM_DATE_TIME = 'videoCallInfo[i].dateTime',

  INTERACTION_CATEGORY = 'interactionCategory',

  AGREEMENT_RESULT_PRESCRIPTION = 'agreements[i].prescription',
  AGREEMENT_VIOLATIONS = 'agreements[i].violations',
  AGREEMENT_VIOLATIONS_VIOLATIONS = 'agreements[i].violations[i].violatedMandatory[i].violations',
  AGREEMENT_VIOLATIONS_VIOLATION_FIX_FACT_METHOD = 'agreements[i].violations[i].violatedMandatory[i].violations[i].fixFactMethod',
  AGREEMENT_VIOLATIONS_VIOLATION_FIXES = 'agreements[i].violations[i].violatedMandatory[i].violations[i].fixes',
  AGREEMENT_VIOLATIONS_VIOLATION_FIXES_TYPES = 'agreements[i].violations[i].violatedMandatory[i].violations[i].fixes[i].type',
  AGREEMENT_VIOLATIONS_VIOLATION_FIXES_TYPE = 'agreements[i].violations[i].violatedMandatory[i].violations[i].fixes[i].type[i].value',
  AGREEMENT_VIOLATIONS_VIOLATION_FIXES_TYPE_EXPLANATION = 'agreements[i].violations[i].violatedMandatory[i].violations[i].fixes[i].explanationMaterial',
  AGREEMENT_VIOLATIONS_VIOLATION_FIXES_TYPE_EXPLANATION_REACT_QUILL_EDITOR = 'agreements[i].violations[i].violatedMandatory[i].violations[i].fixes[i].explanationMaterialReactQuillEditor',
  AGREEMENT_VIOLATIONS_VIOLATION_FIXES_METHOD = 'agreements[i].violations[i].violatedMandatory[i].violations[i].fixes[i].method',
  AGREEMENT_VIOLATIONS_VIOLATION_FIXES_FILES = 'agreements[i].violations[i].violatedMandatory[i].violations[i].fixes[i].attachments',
  AGREEMENT_VIOLATIONS_VIOLATION_FIXES_FILES_VIDEO_LINK = 'agreements[i].violations[i].violatedMandatory[i].violations[i].fixes[i].attachments[i].link.value',
  AGREEMENT_VIOLATIONS_VIOLATION_FIXES_GRADE = 'agreements[i].violations[i].violatedMandatory[i].violations[i].fixes[i].grade',
  AGREEMENT_PETITION_ORGANIZATION_TYPE = 'agreements[i].petitionOrganizationType',
  AGREEMENT_PETITION_ATTACHMENT = 'agreements[i].petitionAttachment',
  AGREEMENT_PETITION_ORGANIZATION_INN = 'agreements[i].petitionOrganization.inn',
  AGREEMENT_PETITION_ORGANIZATION_OGRN = 'agreements[i].petitionOrganization.ogrn',
  AGREEMENT_PETITION_ORGANIZATION_SNILS = 'agreements[i].petitionOrganization.snils',
  AGREEMENT_PETITION_ORGANIZATION_SUBJECT_TYPE = 'agreements[i].petitionOrganization.subjectType',
  AGREEMENT_PETITION_ORGANIZATION_ORGANIZATION_NAME = 'agreements[i].petitionOrganization.organizationName',
  AGREEMENT_PETITION_ORGANIZATION_ORGANIZATION_LOCATION_ADDRESS = 'agreements[i].petitionOrganization.locationAddress',
  AGREEMENT_APPROVAL_OF_AGREEMENT = 'agreements[i].approvalOfAgreement',
  AGREEMENT_APPROVAL_OF_AGREEMENT_ATTACHMENT = 'agreements[i].approvalOfAgreementAttachment',
  AGREEMENT_ELIMINATE_VIOLATIONS_NUMBER = 'agreements[i].eliminateViolationsNumber',
  AGREEMENT_CONCLUSION_DATE = 'agreements[i].conclusionDate',
  AGREEMENT_COMPLETION_DATE = 'agreements[i].termOfExecutionAgreement',
  AGREEMENT_ELIMINATE_VIOLATIONS_ATTACHMENT = 'agreements[i].eliminateViolationsAttachment',
  AGREEMENT_APPLICATION_FOR_CONSIDERATION_ATTACHMENT = 'agreements[i].applicationForConsiderationAttachment',
  AGREEMENT_VIOLATION_CORRECTION_PROGRAM_ATTACHMENTS = 'agreements[i].violationCorrectionProgramAttachments',
  AGREEMENT_APPROVE_INFO_PROSECUTOR_ORGANIZATION = 'agreements[i].prosecutorOrganization',
  AGREEMENT_FIO_SIGNER = 'agreements[i].fioSigner',
  AGREEMENT_TITLE_SIGNER = 'agreements[i].titleSigner',
  AGREEMENT_APPROVE_INFO_NOTE = 'agreements[i].approveInfo.note',
  AGREEMENT_APPROVE_INFO_APPROVED = 'agreements[i].approveInfo.approved',
  AGREEMENT_APPROVE_INFO_NUMBER_DECISION = 'agreements[i].approveInfo.numberDecision',
  AGREEMENT_APPROVE_INFO_DATE_DECISION = 'agreements[i].approveInfo.dateDecision',
  AGREEMENT_APPROVE_INFO_WHO_MADE_DECISION = 'agreements[i].approveInfo.whoMadeDecision',
  AGREEMENT_APPROVE_INFO_TITLE_SIGNER = 'agreements[i].approveInfo.titleSigner',
  AGREEMENT_APPROVE_INFO_ATTACHMENT = 'agreements[i].approveInfo.attachment',
  AGREEMENT_TERMINATE_TERMINATION_REASONS = 'agreements[i].terminate.terminationReasons',
  AGREEMENT_TERMINATE_TERMINATION_REASONS_ITEM = 'agreements[i].terminate.terminationReasons[i]',
  AGREEMENT_TERMINATE_DECISION_TERMINATION_ATTACHMENT = 'agreements[i].terminate.decisionTerminationAttachment',
  AGREEMENT_TERMINATE_TITLE_SIGNER = 'agreements[i].terminate.titleSigner',
  AGREEMENT_TERMINATE_TITLE_SIGNER_LABEL = 'agreements[i].terminate.titleSigner.label',
  AGREEMENT_TERMINATE_FIO_SIGNER = 'agreements[i].terminate.fioSigner',
  AGREEMENT_EXECUTION_DECISION = 'agreements[i].execution.decision',
  AGREEMENT_EXECUTION_EXECUTION_DATE = 'agreements[i].execution.executionDate',
  AGREEMENT_EXECUTION_TITLE_SIGNER = 'agreements[i].execution.titleSigner',
  AGREEMENT_EXECUTION_FIO_SIGNER = 'agreements[i].execution.fioSigner',
  AGREEMENT_CHANGE_TYPES = 'agreements[i].changes[i].types',
  AGREEMENT_CHANGE_TYPES_ITEM = 'agreements[i].changes[i].types[i].type',
  AGREEMENT_CHANGE_REASON = 'agreements[i].changes[i].reasons',
  AGREEMENT_CHANGE_REASON_ITEM = 'agreements[i].changes[i].reasons[i]',
  AGREEMENT_CHANGE_ATTACHMENTS = 'agreements[i].changes[i].attachment',
  AGREEMENT_CHANGE_TERM_OF_EXECUTION_AGREEMENT = 'agreements[i].changes[i].termOfExecutionAgreement',
  AGREEMENT_CHANGE_UPDATED_AGREEMENT_ATTACHMENTS = 'agreements[i].changes[i].updatedAgreementAttachment',
  AGREEMENT_CHANGE_PETITION_ATTACHMENTS = 'agreements[i].changes[i].petitionAttachment',
  AGREEMENT_CHANGE_FIO_SIGNER = 'agreements[i].changes[i].fioSigner',
  AGREEMENT_CHANGE_TITLE_SIGNER = 'agreements[i].changes[i].titleSigner',
  NOTE_WARNING_REACT_QUILL_EDITOR = 'noteWarningReactQuillEditor',
  SUBJECT_NOTIFICATIONS = 'subjectNotifications',
}
